import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, BarSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_FUNNEL_FORM_DATA,
    EchartsWaterfallChartProps,
    EchartsWaterfallFormData,
    WaterfallChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
  
export default function transformProps(
    chartProps: EchartsWaterfallChartProps,
): WaterfallChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      showLegend
    }: EchartsWaterfallFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_FUNNEL_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel) : [getColumnLabel(groupby)];
    const keys = data.map(datum =>
      extractGroupbyLabel({ datum, groupby: groupbyLabels, coltypeMapping: {} }),
    );
    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;
  
    const seriesData: DataRecordValue[] = data.map(datum => datum[metricLabel]);

    const series: BarSeriesOption[] = [
      {
        name: metricLabel,
        type: 'bar',
        stack: 'Total',
        coordinateSystem: 'polar',
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {},
      legend: {
        show: showLegend,
        top: 'bottom',
        data: [metricLabel]
      },
      angleAxis: {
        type: 'category',
        data: keys
      },
      radiusAxis: {},
      polar: {},
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  